import { isEmpty } from "lodash";

import Config from "@app/dev/config/main";

import { PinForm } from "./pieces/PinForm";
import { ForgotPasswordConfirm } from "./pieces/ForgotPasswordConfirm";

export const steps = [
  {
    component: PinForm,
    validate: (form, setErrors) => {
      const formErrors = {};

      if (!form.cpf) formErrors.cpf = "Field is required";
      if (form.cpf && form.cpf.length !== 14) formErrors.cpf = "Invalid format";
      if (!form.pin) formErrors.pin = "Field is required";
      if (!form.confirmPin) formErrors.confirmPin = "Field is required";
      if (form.pin && form.pin.length !== 4) formErrors.pin = "Please enter a 4-digits";
      if (form.pin && form.confirmPin && form.pin !== form.confirmPin) formErrors.confirmPin = "PINs don't match";

      setErrors(formErrors);

      return isEmpty(formErrors);
    },
  },
  {
    component: ForgotPasswordConfirm,
    nextButtonText: "Approve",
    validate: (form, setErrors) => {
      const formErrors = {};

      if (!form.adminPassword) formErrors.adminPassword = "Field is required";
      if (form.adminPassword && form.adminPassword !== Config.main.staffPassword)
        formErrors.adminPassword = "Wrong Password";

      setErrors(formErrors);

      return isEmpty(formErrors);
    },
  },
];
